<template>
<div class="relative _tooltip__container">
    <i class="far fa-question-circle text-light"></i>
    <div class="_tooltip">
		<ul id="ttList">
			<li v-for="(item, i) in desc" v-bind:key="i"><b>{{ item.word }}:</b> {{ item.desc }}</li>
		</ul>
    </div>
</div>
</template>


<style>
.relative {
	position: relative;
}
._tooltip__container:hover {
	cursor: pointer;
}
._tooltip__container:hover ._tooltip {
	display: block;
}
._tooltip {
	transition: all .3s ease;
	display: none;
	position: absolute;
    right: -20px;
	top: 30px;
	min-width: 200px;
	max-width: 400px;
	background-color: rgb(235, 237, 239);
	padding: 5px;
	border-radius: 10px;
  	box-shadow:	0 0.0625rem 0.125rem rgba(235, 237, 239, .8);
	  z-index: 1;
	  box-shadow: 0 2px 10px rgba(75, 75, 75, 0.726);
}

._tooltip::before {
	content: '';
	position: absolute;
	width: 0;
	height: 0;
	bottom: 100%;
	right: 1em;
	border: .75rem solid transparent;
	border-top: none;
	border-bottom-color: rgb(235, 237, 239);
	filter: drop-shadow(0 -0.0625rem 0.0625rem rgba(235, 237, 239, .5));
}
#ttList {
	padding: 0;
}
#ttList b{
	font-size: 10px;
}
#ttList li {
	list-style: none;
	font-size: 11px;
	padding-bottom: 5px;
}	
#ttList li:last-child {
	padding-bottom: 0;
}
</style>

<script>
import { cilPencil, cilPeople, cilUserX } from "@coreui/icons";

export default {
	props: {
		desc: Array
	}
}
</script>